import { Container } from '@adobe/aem-react-editable-components';

import { Navigation as NavigationREACT } from './Navigation';
import { AemContainerConfig, NavigationWrapperProps } from './Navigation.types';
import { SortedModelArray, sortAEMModelItemsByOrder } from '@marriott/mi-ui-library';
import { FEATURE_FLAGS } from '@marriott/mi-feature-flag-utils';
import clsx from 'clsx';
export const NavigationWrapper = (props: NavigationWrapperProps) => {
  const cqPath = `${props.cqPath}/primaryNavigation`;
  const primaryNavigationItems: SortedModelArray = props?.model ? sortAEMModelItemsByOrder(props?.model) : [];
  const isLegacyNavFlagEnabled = props.featureFlagLegacyNav?.[FEATURE_FLAGS.EXPERIENCE_MCOM_LEGACY_NAV];

  const isPrimarynavigationAvailable = !!primaryNavigationItems?.length;
  const NavigationConfig: AemContainerConfig = {
    emptyLabel: 'Marriott Navigation',
    isEmpty: () => false,
    resourceType: isLegacyNavFlagEnabled
      ? 'mi-aem-homepage-spa/components/content/primaryNavigation'
      : 'mi-aem-common-spa/components/content/globalnav/primaryNavigation',
    isInEditor: !!props?.isAuthorMode,
    cqPath: cqPath,
  };

  return isPrimarynavigationAvailable ? (
    <Container
      className={clsx('primary-navigation-wrapper', { 'py-0': props?.isAuthorMode })}
      {...NavigationConfig}
      childPages={
        <NavigationREACT
          primaryNavigationItems={primaryNavigationItems}
          cqPath={cqPath}
          isAuthorMode={props?.isAuthorMode}
          utilityNavigation={props.utilityNavigation}
          setIsMegaMenuActive={props?.setIsMegaMenuActive}
          megaMenuCloseButtonLabel={props?.model?.resourceProperties?.megaMenuCloseButton}
          featureFlagLogo={props?.featureFlagLogo}
          featureFlagLegacyNav={props.featureFlagLegacyNav}
        />
      }
    />
  ) : (
    <div />
  );
};
